var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.7,91.6c-8.8-7.8-22.3-7.1-30.1,1.7c-7.2,8.1-7.2,20.3,0,28.4c74,74.2,74,194.3,0,268.5 c-8.8,7.8-9.6,21.3-1.7,30.1s21.3,9.6,30.1,1.7c0.6-0.5,1.2-1.1,1.7-1.7C534.4,329.6,534.4,182.4,443.7,91.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386,155.6c-8.2-8.5-21.7-8.7-30.2-0.5s-8.7,21.7-0.5,30.2c0.2,0.2,0.3,0.4,0.5,0.5 c38.7,38.8,38.7,101.7,0,140.5c-8.5,8.2-8.7,21.7-0.5,30.2c8.2,8.5,21.7,8.7,30.2,0.5c0.2-0.2,0.4-0.3,0.5-0.5 C441.3,300.9,441.3,211.1,386,155.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.8,4.4C230,16.6,172.3,53.2,133.7,106.7h-27.1C47.8,106.7,0.1,154.5,0,213.3v85.3 c0.1,58.9,47.8,106.6,106.7,106.7h27.1c38.6,53.5,96.3,90.1,161.1,102.3c11.6,2.1,22.7-5.5,24.8-17.1c0.2-1.3,0.4-2.6,0.4-3.9V25.4 c0-11.8-9.6-21.3-21.3-21.3C297.4,4.1,296.1,4.2,294.8,4.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.4880926f7e90f5b2842401d3d8f08553.svg";
export { ForwardRef as ReactComponent };